export const LISTING_TUPLE = '(uint256 listingId,uint256 sourceListingId,uint256 tokenId,address seller,address currency,uint256 price,uint64 expiresAt,uint16 projectFeeBps,uint16 platformFeeBps,uint16 royaltyBps,uint8 royaltyMode,address projectFeeRecipient,address platformFeeRecipient,address royaltyRecipient,uint256 projectFeeAmount,uint256 platformFeeAmount,uint256 royaltyAmount,bool active,address migratedTo)'
export const SALE_TUPLE = '(uint256 saleId,uint256 listingId,uint256 tokenId,address seller,address buyer,address currency,uint256 price,uint256 sellerProceeds,uint256 projectFeeAmount,uint256 platformFeeAmount,uint256 royaltyAmount,uint64 soldAt)'

export const MARKETPLACE_FACTORY_ABI = [
    'function platformFeeBps() view returns (uint16)',
    'function platformFeeRecipient() view returns (address)',
    'function getMarketRecord(address market) view returns ((address market,address creator,address nft,uint16 version,uint64 createdAt))',
    'function isMigrationApproved(address source,address target) view returns (bool)',
]

export const MARKETPLACE_ABI = [
    'event ListingCreated(uint256 indexed listingId,uint256 indexed tokenId,address indexed seller,address currency,uint256 price,uint64 expiresAt)',
    'event ListingCancelled(uint256 indexed listingId,uint256 indexed tokenId,address indexed seller)',
    'event ListingPurchased(uint256 indexed listingId,uint256 indexed tokenId,address indexed buyer,address seller,address currency,uint256 price)',
    'function factory() view returns (address)',
    'function nft() view returns (address)',
    'function owner() view returns (address)',
    'function pendingOwner() view returns (address)',
    'function marketVersion() view returns (uint16)',
    'function defaultSettlementToken() view returns (address)',
    'function projectFeeBps() view returns (uint16)',
    'function projectFeeRecipient() view returns (address)',
    'function royaltyMode() view returns (uint8)',
    'function customRoyaltyBps() view returns (uint16)',
    'function customRoyaltyRecipient() view returns (address)',
    'function metadataURI() view returns (string)',
    'function paused() view returns (bool)',
    'function retired() view returns (bool)',
    'function migrationActive() view returns (bool)',
    'function migrationStarted() view returns (bool)',
    'function migrationTarget() view returns (address)',
    'function migrationCursor() view returns (uint256)',
    'function activeListingCount() view returns (uint256)',
    'function totalSales() view returns (uint256)',
    'function totalVolume(address currency) view returns (uint256)',
    `function getListingByTokenId(uint256 tokenId) view returns (${LISTING_TUPLE})`,
    `function getActiveListingsPage(uint256 offset,uint256 limit) view returns (${LISTING_TUPLE}[] page)`,
    `function getSellerListingsPage(address seller,uint256 offset,uint256 limit) view returns (${LISTING_TUPLE}[] page,uint256 total)`,
    `function getSalesPage(uint256 offset,uint256 limit) view returns (${SALE_TUPLE}[] page,uint256 total)`,
    `function getBuyerPurchasesPage(address buyer,uint256 offset,uint256 limit) view returns (${SALE_TUPLE}[] page,uint256 total)`,
    `function getSellerSalesPage(address seller,uint256 offset,uint256 limit) view returns (${SALE_TUPLE}[] page,uint256 total)`,
    'function createListing(uint256 tokenId,uint256 price,uint64 expiresAt) returns (uint256 listingId)',
    'function createListings((uint256 tokenId,uint256 price,uint64 expiresAt)[] inputs) returns (uint256[] listingIds)',
    'function updateListing(uint256 tokenId,uint256 newPrice,uint64 newExpiresAt)',
    'function cancelListing(uint256 tokenId)',
    'function buy(uint256 tokenId) payable',
    'function setDefaultSettlementToken(address token)',
    'function setProjectFee(uint16 newBps,address newRecipient)',
    'function setRoyaltyConfig(uint8 newMode,uint16 newBps,address newRecipient)',
    'function setMetadataURI(string newURI)',
    'function setPaused(bool newPaused)',
    'function transferOwnership(address newOwner)',
    'function acceptOwnership()',
    'function beginMigration(address target)',
    'function cancelMigration()',
    'function migrateBatch(uint256 limit)',
]

export const MARKETPLACE_ERC721_ABI = [
    'function name() view returns (string)',
    'function symbol() view returns (string)',
    'function owner() view returns (address)',
    'function balanceOf(address owner) view returns (uint256)',
    'function ownerOf(uint256 tokenId) view returns (address)',
    'function tokenURI(uint256 tokenId) view returns (string)',
    'function totalSupply() view returns (uint256)',
    'function tokensOfOwner(address owner) view returns (uint256[])',
    'function tokensOfOwnerIn(address owner,uint256 start,uint256 stop) view returns (uint256[])',
    'function tokenOfOwnerByIndex(address owner,uint256 index) view returns (uint256)',
    'function isApprovedForAll(address owner,address operator) view returns (bool)',
    'function setApprovalForAll(address operator,bool approved)',
]

export const MARKETPLACE_ERC20_ABI = [
    'function name() view returns (string)',
    'function symbol() view returns (string)',
    'function decimals() view returns (uint8)',
    'function balanceOf(address owner) view returns (uint256)',
    'function allowance(address owner,address spender) view returns (uint256)',
    'function approve(address spender,uint256 amount) returns (bool)',
]
